import React from "react";

const AiMlDevelop = () => {
  return (
    <div className=" p-6">
      <div className="flex flex-col-reverse lg:flex-row items-center lg:space-x-16">
        {/* Text Section */}
        <div className="lg:w-1/2  lg:text-left p-4">
          <h2 className="text-2xl md:text-4xl lg:text-5xl font-bold text-gray-800 mb-4">
           AI-powered automation solutions for startups
          </h2>
          <p className="sm:text-base md:text-lg lg:text-xl text-gray-600 leading-relaxed mb-3">
          <a  className="  relative   
  before:content-[''] before:absolute before:left-1/2 before:-bottom-1 
  before:h-[2px] before:w-0 before:bg-green-600 
  before:transition-all before:duration-300 
  hover:before:left-0 hover:before:w-full text-green-600 font-bold" href="https://ayanshtechnology.com/voice-assistant"> AI-powered automation solutions </a> for startups help growing businesses work smarter, faster, and more efficiently. With intelligent workflows, smart chatbots, automated data processing, and AI-driven decision support, we help startups reduce manual tasks and focus on scaling their core operations. Our automation services improve productivity, enhance customer experience, and lower operational costs. Whether you're launching a new product or expanding your team, our AI solutions simplify your processes and support sustainable growth.
          </p>
          <a href="/voice-assistant">
            <button className="bg-gradient-to-r from-blue-600 to-green-500 text-white px-6 py-3 rounded-full group hover:from-blue-900 hover:to-blue-600">
              View More
            </button>
          </a>
        </div>

        {/* Image Section */}
        <div className="flex justify-center lg:w-1/2 mb-6 lg:mb-0">
          <img
            src="/assets/images/homeImages/ai-images.png"
            alt="AI/ML Development"
            className="w-full h-auto sm:w-3/4 md:w-2/3 lg:w-full object-contain"
          />
        </div>
      </div>
    </div>
  );
};

export default AiMlDevelop;
